import { render, staticRenderFns } from "./SelectBlock.vue?vue&type=template&id=ab42d53e&scoped=true&"
import script from "./SelectBlock.vue?vue&type=script&lang=js&"
export * from "./SelectBlock.vue?vue&type=script&lang=js&"
import style0 from "./SelectBlock.vue?vue&type=style&index=0&id=ab42d53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab42d53e",
  null
  
)

export default component.exports